import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceSubmitProjectReportNotificationState = createStateReducer(
  initialState,
  {
    [events.submitProjectReportSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "submitProjectReport",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.submitProjectReportFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "submitProjectReport",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceSubmitProjectReportNotificationState };
